import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { Cacheable } from 'ngx-cacheable';
import { MaritalStatus } from '../api/src/app/models/REGBP-V1.0.0/marital-status.model';

@Injectable({
  providedIn: 'root'
})
export class MaritalStatusFacade {
  constructor(public regbpService: RegbpService) {}

  @Cacheable({ maxCacheCount: 3 })
  getMaritalStatuses(language: string): Observable<KeyValue<string, string>[]> {
    return this.regbpService.getMaritalStatusList(language).pipe(
      map((results: any) => results.$response.body.values),
      map((results: MaritalStatus[]) =>
        results
          .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))
          .map((maritalStatusObject: MaritalStatus) => {
            return {
              key: maritalStatusObject.code,
              value: maritalStatusObject.value
            };
          })
      )
    );
  }
}
